module.exports = __webpack_public_path__ + "img/1 (116).0f1865c3.png";